// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"6b71a1dc","332":"9985d997"}[chunkId] + ".chunk.js";
};